import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const SECONDARY_MAIN = '#54FBF5';

const StyledLink = styled('a')({
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
  '&:hover': { textDecoration: 'underline' },
  '&:focus-visible': {
    outline: '2px solid #54FBF5',
    outlineOffset: '2px',
    borderRadius: '2px',
  },
});

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: { xs: 3, md: 6 },
        backgroundColor: '#1a1a1a',
        color: '#fff',
      }}
    >
      <Box sx={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            gap: 3,
          }}
        >
          <Box>
            <img
              src="/scale.png"
              alt="ScaleCapacity logo"
              style={{
                height: '32px',
                width: 'auto',
                filter: 'brightness(0) invert(1)',
              }}
            />
          </Box>
          <Box>
            <Typography variant="body2" sx={{ color: '#999', mb: 1 }}>
              Need help? Contact our support team
            </Typography>
            <StyledLink
              href="mailto:accesswcag-support@scalecapacity.com"
              sx={{ color: SECONDARY_MAIN, fontSize: '0.95rem' }}
            >
              accesswcag-support@scalecapacity.com
            </StyledLink>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ color: '#999' }}>
              Powered by{' '}
              <StyledLink
                href="https://www.scalecapacity.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ScaleCapacity (opens in new tab)"
                sx={{ color: SECONDARY_MAIN }}
              >
                ScaleCapacity
              </StyledLink>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
